import React, { useState, useEffect } from 'react';
import { Widget, Table, ColumnProps, MasterDetailForm, Row, Col } from '@digital/ui';
import { Icon, Collapse } from 'antd';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { ProjetoControleNaoPrevisto, getProjetosDoadoresControleNaoPrevisto } from '@app/api/naoPrevistos/controle';
import StatusCircle from '@app/components/statusCircle';

interface Props {
    ano: number;
}

const AbaDoacoes = ({ano}: Props) => {
    const { Panel } = Collapse;
    const [dataSource, setDataSource] = useState<ProjetoControleNaoPrevisto[]>();

    const generateRowKey = (data: ProjetoControleNaoPrevisto, keyParent?: string) => {
        data.key = keyParent ? `${keyParent}-${data.codigoProjeto}` : data.codigoProjeto;

        if (data.children && data.children.length)
            data.children.forEach(child => generateRowKey(child, data.key));

        return data;
    };

    useEffect(() => {
        if (ano) {
            getProjetosDoadoresControleNaoPrevisto(ano).then((data) => {
                setDataSource(data?.map(d => generateRowKey(d)));
            });
        }
    }, [ano]);

    const columns: ColumnProps<ProjetoControleNaoPrevisto>[] = [
        {
            dataIndex: 'dropDown'
        },
        {
            title: 'Código',
            dataIndex: 'codigoProjeto',
            ...mountFormFilterDropDown('codigoProjeto', 'Pesquisar'),
            render: (_text, row) => {    
                return (
                    <div style={{ textAlign: 'left' }}>
                        {row.codigoProjeto}
                    </div>
                );
            }
        },
        {
            title: 'Nome',
            dataIndex: 'nomeProjeto',
            ...mountFormFilterDropDown('nomeProjeto', 'Pesquisar')
        },
        {
            title: 'Orçado',
            dataIndex: 'valorOrcado',
            align: 'center',
        },
        {
            title: 'Contratado',
            dataIndex: 'valorContratado',
            align: 'center',
        },
        {
            title: 'Executado',
            dataIndex: 'valorExecutado',
            align: 'center',
        },
        {
            title: 'Requisitado',
            dataIndex: 'valorRequisitado',
            align: 'center',
        },
        {
            title: 'Compromissado',
            dataIndex: 'valorCompromissado',
            align: 'center',
        },
        {
            title: 'A Contratar',
            dataIndex: 'valorAContratar',
            align: 'center',
        },
        {
            title: 'Forecast',
            dataIndex: 'valorForecast',
            align: 'center',
        },
        {
            title: 'Saldo',
            dataIndex: 'valorSaldo',
            align: 'center',
        },
        {
            title: 'Doação',
            dataIndex: 'valorDoacao',
            align: 'center',
        },
        {
            title: 'Diferença',
            dataIndex: 'valorDiferenca',
            align: 'center',
        },
        {
            title: 'Situação',
            dataIndex: 'situacaoCor',
            align: 'center',
            render: (_text, row, _index) => {
                return <StatusCircle noPrazo={ row.situacaoCor && row.situacaoCor.toLowerCase() === "green"} valorLabel={''} />
            },
        },
    ];

    return(
        <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type='arrows-right_4' />}>
            <Panel key='1' header='Doações' style={{ border: 0 }}>
                <MasterDetailForm>
                    <Widget>
                        <Row>
                            <Col span={12}>
                                <Table
                                    className='ColorTableLevel0'
                                    rowKey='key'
                                    key='key'
                                    columns={columns}
                                    dataSource={dataSource}
                                    pagination={{ pageSize: 10 }}
                                />
                            </Col>
                        </Row>
                    </Widget>
                </MasterDetailForm>
            </Panel>
        </Collapse>
    );
};

export default AbaDoacoes;